import { render, staticRenderFns } from "./mastery-content-completion.vue?vue&type=template&id=35b5df60&scoped=true&"
import script from "./mastery-content-completion.ts?vue&type=script&lang=ts&"
export * from "./mastery-content-completion.ts?vue&type=script&lang=ts&"
import style0 from "./mastery-content-completion.scss?vue&type=style&index=0&id=35b5df60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b5df60",
  null
  
)

export default component.exports